import { useQuery } from '@tanstack/react-query';
import { websitesApi } from '../services/websitesApi';

export const useModels = () => {
  return useQuery({
    queryKey: ['website-models'],
    queryFn: () => websitesApi.getModels(),
    staleTime: 30 * 60 * 1000, // 30 min - models rarely change
  });
};

export const useModel = (modelId?: string) => {
  return useQuery({
    queryKey: ['website-models', modelId],
    queryFn: () => websitesApi.getModel(modelId!),
    enabled: !!modelId,
    staleTime: 30 * 60 * 1000,
  });
};
